import { render, staticRenderFns } from "./FacebookReel.vue?vue&type=template&id=02453292&scoped=true"
import script from "./FacebookReel.vue?vue&type=script&lang=js"
export * from "./FacebookReel.vue?vue&type=script&lang=js"
import style0 from "./FacebookReel.vue?vue&type=style&index=0&id=02453292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02453292",
  null
  
)

export default component.exports